export default "__VITE_ASSET__0752a78b__"